import { GET } from '@/requests/ac';
import { ENDPOINT_PRT_FILE } from '@/config';

export const prtAuthFileUrl = (item) => buildAuthFileUrl(ENDPOINT_PRT_FILE, item && item.id);

export const getBhpFileName = (item) => {
  if (!item || item.bhp_file_name == null) return null;
  const name = String(item.bhp_file_name).trim();
  if (!name || name === 'null') return null;
  return name;
};

export const buildAuthFileUrl = (endpoint, id) => {
  if (!id || !endpoint) return null;
  return `${String(endpoint).replace(/\/?$/, '/')}${id}/auth_file/`;
};

const isAbsoluteUrl = (value) => /^https?:\/\//i.test(value);

export const hasPrtFile = (item) => !!(item && (prtAuthFileUrl(item) || getBhpFileName(item) || item.file_name));

const resolveRedirectUrl = (location, requestUrl) => {
  if (!location) return null;
  try {
    return new URL(location, requestUrl).toString();
  } catch {
    return location;
  }
};

const resolveFallbackRedirectUrl = (fallbackRedirectUrl, requestUrl) => {
  if (!fallbackRedirectUrl) return null;
  if (isAbsoluteUrl(fallbackRedirectUrl)) return fallbackRedirectUrl;
  return resolveRedirectUrl(fallbackRedirectUrl, requestUrl);
};

const fetchAuthenticatedFileResponse = async (url, { beforeFetch, fallbackRedirectUrl } = {}) => {
  if (!url) throw new Error('File not found');
  if (beforeFetch) await beforeFetch();

  const response = await fetch(url, { ...GET(), redirect: 'manual' });

  if (response.status >= 300 && response.status < 400) {
    const redirectUrl = resolveRedirectUrl(response.headers.get('Location'), url)
      || resolveFallbackRedirectUrl(fallbackRedirectUrl, url);
    if (!redirectUrl) throw new Error('Redirect without location');
    return { type: 'redirect', redirectUrl };
  }

  if (response.type === 'opaqueredirect' || response.status === 0) {
    const redirectUrl = resolveFallbackRedirectUrl(fallbackRedirectUrl, url);
    if (redirectUrl) return { type: 'redirect', redirectUrl };
    throw new Error('Redirect without location');
  }

  if (!response.ok) throw new Error(`respuesta insatifactoria, codigo:${response.status}`);
  return { type: 'blob', blob: await response.blob() };
};

export const fetchAuthenticatedFileBlobUrl = async (url, { beforeFetch, fallbackRedirectUrl } = {}) => {
  const result = await fetchAuthenticatedFileResponse(url, { beforeFetch, fallbackRedirectUrl });
  if (result.type === 'redirect') return result.redirectUrl;
  return URL.createObjectURL(result.blob);
};

export const openAuthenticatedFile = async (url, { beforeFetch, fallbackRedirectUrl } = {}) => {
  if (!url) throw new Error('File not found');

  // Reserve the tab while the click still counts as user activation: browsers block
  // popups opened after the awaited fetch resolves, so only the first one would open.
  const fileWindow = window.open('', '_blank');
  try {
    const result = await fetchAuthenticatedFileResponse(url, { beforeFetch, fallbackRedirectUrl });
    const targetUrl = result.type === 'redirect'
      ? result.redirectUrl
      : URL.createObjectURL(result.blob);

    if (fileWindow) {
      fileWindow.location.replace(targetUrl);
      return;
    }
    window.open(targetUrl, '_blank', 'noopener,noreferrer');
  } catch (error) {
    if (fileWindow) fileWindow.close();
    throw error;
  }
};

export const openAuthenticatedPrtFile = async (item, beforeFetch) => {
  const url = prtAuthFileUrl(item);
  if (!url) throw new Error('File not found');

  return openAuthenticatedFile(url, {
    beforeFetch,
    fallbackRedirectUrl: getBhpFileName(item),
  });
};
